<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("state", 2) }}
      </div>
      <router-link class="btn-blue" to="states"
        >{{ $tc("state", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <!-- CINEMAS SELECTION -->
          <div
            v-for="(item, index) in States"
            :key="index"
            v-if="item.fieldname !== 'state_id'"
            class="col-lg-6 col-xl-3 mb-4 align-self-center"
          >
            <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @focus="onFocusHandler"
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                    placeholder="."
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  />
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <!-- <Tooltip :title="$t(item.tooltip)" /> -->
              </div>
              <p class="error_message">
                <span v-if="errors.has(item.fieldname)">{{
                  errors.first(`${item.fieldname}`)
                }}</span>
              </p>
            </div>
            <div v-if="item.type === 'radio'" class="d-flex align-items-center">
              <label class="mb-4 mr-2">{{ $t("active") }}</label>

              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox mb-4"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>

            <div v-if="item.type === 'dropdown'">
              <div v-if="item.fieldname === 'country_id'">
                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search country"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchCountry()"
                        v-on:keydown="onSearchCountry()"
                        v-on:search="onSearchCountry()"
                        v-model="searchCountry"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in countryList"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.country_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <p class="error_msg">
                  <span v-if="submitted && item.dropdownSelected.length == 0">{{
                    msgcountry
                  }}</span>
                </p>
              </div>
              <!--<div v-if="item.fieldname === 'state_list'">
                <div class>
                  <label>{{ $tc('State', 1) }}</label>
                </div>
                <div class>
              <b-dropdown :text="item.fieldvalue" variant="dropdown-curve" class="w-100">-->
              <!-- _getCountryList(item.label, null) -->
              <!--<b-dropdown-item
                      v-for="(dropdownItem,dropdownIndex) in stateList"
                      :key="dropdownIndex"
                      href="#"
                      @click="onDropdownChange($event, item.label,dropdownItem, index)"
                    >{{ dropdownItem.state_name }}</b-dropdown-item>
                  </b-dropdown>
                  <p v-if="submitted" class="error_msg">Title cannot be empty</p>
                </div>
              </div>-->
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="onFinalSubmit(true)"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click.prevent.stop="onResetForm()" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button class="btn-outline-grey" variant="default" to="states">{{
              $t("cancel")
            }}</b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import States from "@/helper/formJSONMaster/States";
const dropdownvalidation = ["country_id"];

export default {
  data() {
    return {
      btenable: false,
      msgcountry: "Please Select Country.",
      States: States.ms_states,
      // v-validate="'required|email'"
      submitted: false,
      Methods: States.Methods,
      countryList: [],
      countryListCopy: [],
      searchCountry: "",
      //stateList: []
    };
  },
  beforeMount() {
    this.getCountryList();
    this.onResetForm();
  },
  mounted() {
    console.log("States :", States);
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getStateList: function (id) {
      this.stateList = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        params: { id: "country_id-" + id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.stateList = data.Records;
            this.States.map((x) => {
              if (x.fieldname === "state_list") {
                x.fieldvalue = "Select State";
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onSearchCountry: function () {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.countryList = this.countryListCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.countryListCopy;
      }
    },
    getCountryList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      // this.States[mainIndex].fieldvalue = item.country_name;
      // console.log("item :", item);
      this.States[mainIndex].fieldvalue = item.country_id;
      this.States[mainIndex].dropdownSelected = item.country_name;

      /*if (type === "country") {
        this.States[mainIndex].fieldvalue = item.country_id;
        this.States[mainIndex].dropdownSelected = item.country_name;
        this.getStateList(item.country_id);
      } else if (type === "state") {
        this.States[mainIndex].dropdownSelected = item.state_name;
        this.States[mainIndex].fieldvalue = item.state_id;

      }*/
    },
    onResetForm: function () {
      this.States.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        }
      });
    },
    dropdownValidation: function () {
      // this.dropdownValidation()
      let value = false;
      // dropdownvalidation.map((x)=>{
      //   let array =
      //   if(array.length > 0){
      //   }
      // });
      return this.States.filter(
        (y) => y.type === "dropdown" && y.fieldname === x && y.fieldvalue == ""
      ).length > 0
        ? true
        : false;
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.States[3].fieldvalue == "") {
            return;
          } else {
            this.btenable = true;
            let body = this.getRequestBody("POST", this.States, this.Methods);

            MasterService.GlobalRequest(body)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  this.onResetForm();
                  if (redirect) {
                    this.$router.push({
                      path: "/master/states",
                    });
                  }
                } else {
                  // Show Error Message:
                  this.$toasted.show(data.message);
                  console.log("data.message :", data.message);
                }
              })
              .catch((error) => {
                // Catch Error:
                console.log("Catch Error On onFinalSubmit :", error);
              });
          }
        } else {
          this.submitted = true;

          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/StatesComponents/addState.vue